import React from 'react';

import { Box, Flex, Link } from 'pounceV2';
import { Link as RRLink } from 'react-router-dom';
import { EditorContent, JSONContent } from '@tiptap/react';
import useRichTextEditorV3, { RichTextEditorStylesV3 } from 'Hooks/useRichTextEditorV3';

interface CommentProps {
  content: JSONContent | string;
}
const CommentV3 = ({ content }: CommentProps) => {
  const { formattedContent, aiStream } = React.useMemo(() => {
    if (typeof content === 'string') {
      // Extract the aistream ID if present
      let formattedString = content;
      let aiStreamId = '';

      // ensure that the ai stream is present in the comment
      const linkIndex = content.indexOf('<br /><br /><a href=');
      const aiStreamMatch = content.match(/aiStream=([^"&]+)/);
      if (aiStreamMatch && aiStreamMatch[1] && linkIndex !== -1) {
        // eslint-disable-next-line prefer-destructuring
        [, aiStreamId] = aiStreamMatch;
        // This is an absolute url that we need to remove and replace with a router link
        // to ensure that there are no page reloads.
        // The reason that this is absolute is because the comment is also sent to destinations e.g. Jira
        formattedString = content.substring(0, linkIndex);
      }

      return { formattedContent: formattedString, aiStream: aiStreamId };
    }

    return { formattedContent: content };
  }, [content]);
  const editor = useRichTextEditorV3({ editable: false, content: formattedContent });
  return (
    <Flex flexDirection="column">
      <RichTextEditorStylesV3>
        <EditorContent editor={editor} />
        {aiStream && (
          <Box mt={4}>
            <Link as={RRLink} aria-label="Link to AI Triage Alert" to={`?aiStream=${aiStream}`}>
              Panther AI Alert Triage
            </Link>
          </Box>
        )}
      </RichTextEditorStylesV3>
    </Flex>
  );
};

export default CommentV3;
